import cx from 'classnames';
import { Image } from 'platform-components';
import React from 'react';

import { ImageData } from '../typings';

import './certificate-modal__image.scss';

interface Props {
    imageData: ImageData;
}
export const CertificateModalImage = ({ imageData }: Props) => {
    if (!imageData) {
        return null;
    }

    return (
        <Image
            alt=""
            className={cx('certificate-modal__certificate-image', imageData.mix)}
            src={imageData.src}
            srcSet={imageData.srcSet}
        />
    );
};
